import { DriverTypes, InitialDriver } from './types';
export const getDriver = (payload: InitialDriver) => {
  return {
    type: DriverTypes.GET_DRIVER,
    payload,
  };
};

export const setRefuseDatas = (payload: InitialDriver) => {
  return {
    type: DriverTypes.SET_REFUSED_DATAS,
    payload,
  };
};

export const setRefuseDatasDraft = (payload: any) => {
  return {
    type: DriverTypes.SET_REFUSED_DATAS_DRAFT,
    payload,
  };
};

export const setClearAllRefusedDatas = () => {
  return {
    type: DriverTypes.SET_CLEAR_ALL_REFUSED_DATAS,
  };
};
